
import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';
import { companyInfo } from '../data';

const Footer = () => {
  return (
    <footer className="bg-[#1b4c2e] text-gray-300 pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <Link to="/" className="inline-block">
              <img 
                src="/images/smithlogowhite.png" 
                alt={companyInfo.name} 
                className="h-12 w-auto" 
              />
            </Link>
            <p className="text-sm leading-relaxed max-w-xs">
              Professionelt anlægsarbejde og haveprojekter i Nordjylland. Vi skaber drømmehaven med fokus på kvalitet og holdbarhed.
            </p>
            <div className="flex space-x-4 pt-2">
              <a 
                href={companyInfo.facebook} 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-gray-800 p-2 rounded-full hover:bg-green-600 transition-colors"
                aria-label="Følg os på Facebook"
              >
                <Facebook size={20} className="text-white" />
              </a>
              <a 
                href={companyInfo.instagram} 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-gray-800 p-2 rounded-full hover:bg-green-600 transition-colors"
                aria-label="Følg os på Instagram"
              >
                <Instagram size={20} className="text-white" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold">Genveje</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-green-500 transition-colors">Forside</Link></li>
              <li><Link to="/ydelser" className="hover:text-green-500 transition-colors">Ydelser</Link></li>
              <li><Link to="/om-os" className="hover:text-green-500 transition-colors">Om os</Link></li>
              <li><Link to="/galleri" className="hover:text-green-500 transition-colors">Galleri</Link></li>
              <li><Link to="/kontakt" className="hover:text-green-500 transition-colors">Kontakt</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold">Vores Ydelser</h4>
            <ul className="space-y-2">
              <li><Link to="/ydelser" className="hover:text-green-500 transition-colors">Anlægsopgaver</Link></li>
              <li><Link to="/ydelser" className="hover:text-green-500 transition-colors">Belægning</Link></li>
              <li><Link to="/ydelser" className="hover:text-green-500 transition-colors">Støttemure</Link></li>
              <li><Link to="/ydelser" className="hover:text-green-500 transition-colors">Rullegræs</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold">Kontakt Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-green-500 shrink-0" />
                <span className="text-sm">{companyInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={20} className="text-green-500 shrink-0" />
                <a href={`tel:${companyInfo.phone.replace(/\s/g, '')}`} className="text-sm hover:text-green-500">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={20} className="text-green-500 shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="text-sm hover:text-green-500 break-all">
                  {companyInfo.email}
                </a>
              </li>
              <li className="pt-2">
                <span className="text-xs uppercase tracking-wider text-gray-500 font-bold">CVR: {companyInfo.cvr}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 text-center text-xs text-gray-500">
          <p>© {new Date().getFullYear()} {companyInfo.name}. Alle rettigheder forbeholdes.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
